module.exports = "/build/web/svg/icon-spinner.b0035155bc20910dc174d218747e8566.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-spinner.svg
// module id = 143
// module chunks = 11